import { render, staticRenderFns } from "./ProductCardSkeleton.vue?vue&type=template&id=2bb4a359&scoped=true"
import script from "./ProductCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ProductCardSkeleton.vue?vue&type=style&index=0&id=2bb4a359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4a359",
  null
  
)

export default component.exports